import React, { useMemo, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Box from "@redbubble/design-system/react/Box";
import Button from "@redbubble/design-system/react/Button";
import Text from "@redbubble/design-system/react/Text";
import ContextVerticalIcon from "@redbubble/design-system/react/Icons/ContextVertical";
import Dropdown, {
  DropdownItem,
  DropdownLink,
  DropdownSection,
} from "@redbubble/design-system/react/Dropdown";
import * as constants from "@redbubble/design-system/react/constants";
import messages from "./messages";
import DeleteCommentModel from "../../DeleteCommentModel";

const ReviewOptions = ({
  commentId,
  deleteComment,
  deleteCommentLoading,
  canDelete,
  canReport,
}) => {
  const composedReportLink = useMemo(
    () => `/objections/add/${commentId}?content_type=Comment`,
    [commentId]
  );

  const [isOpen, setIsOpen] = useState(false);

  const toggleModel = useCallback(
    (state) => () => setIsOpen(state),
    [setIsOpen]
  );

  return (
    <>
      <Dropdown
        placement={constants.BOTTOM_LEFT}
        trigger={(props, ref) => (
          <Button
            iconAfter={<ContextVerticalIcon color="#666E7D" />}
            ref={ref}
            circle
            {...props}
          />
        )}
      >
        <DropdownSection title="Demo" hideTitle>
          {canDelete && (
            <DropdownItem onSelect={toggleModel(true)}>
              <FormattedMessage {...messages.deleteComment}>
                {(text) => (
                  <Box style={{ color: "var(--ds-color-primary)" }}>
                    <Text type="display6" display="block">
                      {text}
                    </Text>
                  </Box>
                )}
              </FormattedMessage>
            </DropdownItem>
          )}
          {canReport && (
            <DropdownLink href={composedReportLink}>
              <FormattedMessage {...messages.reportComment}>
                {(text) => (
                  <Box style={{ color: "var(--ds-color-primary)" }}>
                    <Text type="display6" display="block">
                      {text}
                    </Text>
                  </Box>
                )}
              </FormattedMessage>
            </DropdownLink>
          )}
        </DropdownSection>
      </Dropdown>
      <DeleteCommentModel
        isOpen={isOpen}
        closeModal={toggleModel(false)}
        deleteComment={deleteComment({ callback: toggleModel(false) })}
        deleteCommentLoading={deleteCommentLoading}
      />
    </>
  );
};

ReviewOptions.propTypes = {
  commentId: PropTypes.string.isRequired,
  deleteComment: PropTypes.func.isRequired,
  deleteCommentLoading: PropTypes.bool.isRequired,
  canDelete: PropTypes.bool.isRequired,
  canReport: PropTypes.bool.isRequired,
};

export default React.memo(ReviewOptions);
